import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import RsTable from '@Pages/RetroSynthesis/components/RsTable';
import PlanPredictedItem from '@Pages/RetroSynthesis/EditPlan/AddSteps/components/PlanPredictedItem';
import RsTableHeaderLabel from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderLabel';
import { getSelectionPropsForCheckbox } from '@Pages/RetroSynthesis/EditPlan/AddSteps/utils/selection';
import { Paginator } from '@els/els-react--paginator';
import GoToPage from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogFooter/GoToPage';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';

import './PlanPublishedItems.scss';

function PlanPredictedItems({
  items,
  selectedStepExamplesSearchData,
  predictedExamplesResults,
  selectedItems,
  setSelectedItems,
  fetchData,
  pagination,
}) {
  const resultForExample = (route) =>
    predictedExamplesResults &&
    route &&
    route.routeLayout &&
    route.routeLayout[0].examples &&
    predictedExamplesResults[route.routeLayout[0].examples[0].reactionId];

  const { totalElements, totalPages, size, number } = pagination || {};

  // Selection
  const customContainsFunc = (allItems, newItem) =>
    allItems &&
    allItems.filter(
      (item) =>
        item.confidence === newItem.confidence &&
        item.stepCount === newItem.stepCount &&
        item.routeLayout.length === newItem.routeLayout.length &&
        item.routeLayout?.filter(
          // eslint-disable-next-line sonarjs/no-nested-functions
          (o1) => newItem.routeLayout.some((o2) => isEqual(omit(o1.substance, ['structure']), omit(o2.substance, ['structure']))) // omit structure since marvin id in it may change
        ).length === item.routeLayout.length
    ).length > 0;

  const { isSelected, onSelectionChange } = getSelectionPropsForCheckbox({ selectedItems, setSelectedItems, customContainsFunc });

  return (
    <>
      <RsTable
        className={cn('rs-project-routes-table, plan-predicted-items')}
        dataList={items}
        renderItem={(projectRouteVO) => (
          <PlanPredictedItem
            {...projectRouteVO}
            index={projectRouteVO}
            onSelectionChange={onSelectionChange}
            selected={isSelected(selectedItems, projectRouteVO)}
            result={resultForExample(projectRouteVO)}
            selectedStepExamplesSearchData={selectedStepExamplesSearchData}
          />
        )}
        header={
          <tr className=" c-els-table__row c-els-table__row--head plan-predicted-items__examples__header">
            <th className=" c-els-table__cell c-els-table__basic-cell  c-els-table__cell--header">
              <RsTableHeaderLabel />
            </th>
            <th className=" c-els-table__cell c-els-table__basic-cell  c-els-table__cell--header">Optional single step to be added</th>
            <th className=" c-els-table__cell c-els-table__basic-cell  c-els-table__cell--header">Reaxys Example</th>
          </tr>
        }
      />
      {totalPages > 1 && (
        <div className="plan-published__pagination u-els-padding-left u-els-margin-top-2x">
          <Paginator
            onPageChange={(page) => {
              fetchData({ size, page: page - 1 });
            }}
            resultsPerPage={size}
            totalResults={totalElements}
            currentPage={number + 1}
            shouldShowFirstLastButton
            maxPagesToShow={3}
            a11y={{ name: 'Predicted results', pagingUnitName: 'Page', morePagingUnit: 'More pages' }}
          />
          <GoToPage
            chunksCount={Math.ceil(totalElements / size)}
            onClick={(page) => {
              fetchData({ size, page: page - 1 });
            }}
          />
        </div>
      )}
    </>
  );
}

PlanPredictedItems.propTypes = {
  items: PropTypes.array,
  predictedExamplesResults: PropTypes.object,
  selectedStepExamplesSearchData: PropTypes.object,
  fetchData: PropTypes.func,
  pagination: PropTypes.object,

  // Selection
  selectedItems: PropTypes.arrayOf(PropTypes.object),
  setSelectedItems: PropTypes.func,
};

export default PlanPredictedItems;
